module.exports = __webpack_public_path__ + "img/term_package.777211ff.png";